//third party

import { NgModule } from "@angular/core";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { MaterialModule } from "../../material.module";
import { PipesModule } from "../../pipes/pipes.module";
import { DataTableComponent } from "./DataTable/datatable.component";
import { GraphQlComponent } from "./graphql.component";
import { GraphQlLineChartComponent } from "./LineChart/linechart.component";
import { PieChartComponent } from "./PieChart/piechart.component";
import { GraphQlStackedBarChartPaginationComponent } from "./StackedBarChartPagination/stackedbarchartpagination.component";


@NgModule({
  exports: [
    DataTableComponent,
    GraphQlLineChartComponent,
    PieChartComponent,
    GraphQlStackedBarChartPaginationComponent,
    GraphQlComponent
  ],
  declarations: [
    DataTableComponent,
    GraphQlLineChartComponent,
    PieChartComponent,
    GraphQlStackedBarChartPaginationComponent,
    GraphQlComponent
  ],
  imports: [

    MaterialModule,
    NgxChartsModule
  ]
})
export class GraphQlModule { }
